<template>
  <div class="tour_container row">
    <v-spacer></v-spacer>
    <div class="tour_box col-11 col-sm-9">
      <div class="tour_card d-flex flex-column">
        <div class="triangle"></div>
        <div class="card_text px-5 py-5">{{ text }}</div>
        <v-spacer></v-spacer>
        <div class="card_buttons d-flex justify-space-between px-5 pb-5">
          <v-btn
            class="card_btn"
            width="110px"
            height="50px"
            outlined
            rounded
            color="#2C4370"
            @click="$emit('close', false)"
          >
            Close
          </v-btn>
          <v-btn
            class="card_btn"
            height="50px"
            width="110px"
            rounded
            depressed
            dark
            color="#76CD68"
          >
            Next
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tour",
  data() {
    return {
      text: "Супер текст",
    };
  },
};
</script>
<style scoped>
.tour_container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(44, 67, 112, 0.9);
  z-index: 7;
}
.tour_box {
  margin-top: 125px;
}
.tour_card {
  margin-left: -20px;
  width: 335px;
  height: 224px;
  background: #ffffff;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
  border-radius: 20px;
  position: relative;
}
.triangle {
  position: absolute;
  top: -10px;
  left: 120px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 15px solid #fff;
}
.card_text {
  font-size: 18px;
  color: #2c4370;
}
.card_btn {
  font-size: 18px;
  text-transform: none;
  font-weight: normal;
}
</style>
